// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@conklin/App/Store/Reducers";
import { getSettingsCollection } from "@conklin/App/Store/Selectors/SettingsSelectors";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { useEffect } from "react";

const useLoadPlaces = () => {
    const dispatch = useAppDispatch();
    const { googleApiKey, isGooglePlacesApiLoaded } = useAppSelector(state => ({
        googleApiKey: getSettingsCollection(state).websiteSettings.googleMapsApiKey,
        isGooglePlacesApiLoaded: (state as CustomAppState).xCommon.isGooglePlacesApiLoaded,
    }));

    useEffect(() => {
        if (
            !(
                document.head.querySelector(
                    `script[src="//maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places"]`,
                ) || isGooglePlacesApiLoaded
            )
        ) {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = `//maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places`;
            script.async = true;
            script.id = "google-places";
            document.head.appendChild(script);
            script.onload = () => {
                dispatch({
                    type: "xCommon/update",
                    data: {
                        key: "isGooglePlacesApiLoaded",
                        value: true,
                    },
                } as any);
            };
        }
    }, [isGooglePlacesApiLoaded]);
};

export default useLoadPlaces;
